// src/constants/formFields.js
import {
  TextFields as TextFieldsIcon,
  ShortText as ShortTextIcon,
  List as ListIcon,
  CheckBox as CheckBoxIcon,
  RadioButtonChecked as RadioButtonCheckedIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Numbers as NumbersIcon,
  CalendarToday as DateIcon,
  CloudUpload as FileUploadIcon,
  Star as RatingIcon,
  LinearScale as SliderIcon,
  AccessTime as TimeIcon,
  Link as UrlIcon,
  AttachMoney as CurrencyIcon,
  Person as NameIcon,
  LocationOn as AddressIcon,
  FormatColorText as RichTextIcon,
  Image as ImageIcon,
  TableChart as TableChartIcon,
  PictureAsPdf as PdfIcon,
  // Yeni iconlar
  ToggleOn as ToggleIcon,
  Tune as RangeSliderIcon,
  Palette as ColorPickerIcon,
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  Instagram as InstagramIcon,
  LinkedIn as LinkedInIcon,
  YouTube as YouTubeIcon,
  WhatsApp as WhatsAppIcon,
  Share as SocialIcon,
  Speed as GaugeIcon,
  TrendingUp as ProgressIcon,
  Fingerprint as SignatureIcon,
  Brush as DrawingIcon,
  QrCode as QrCodeIcon,
  // Sürdürülebilirlik iconları
  Park as EcoIcon,
  LocalFlorist as NatureIcon,
  Forest as ForestIcon,
  Calculate as CalculateIcon,
  LocalFlorist as LeafIcon,
  Recycling as RecyclingIcon,
  EmojiEvents as CertificateIcon,
  Park as TreeIcon,
  Public as Co2Icon,
} from '@mui/icons-material';

export const FIELD_CATEGORIES = {
  BASIC: 'Temel Alanlar',
  INPUT: 'Giriş Alanları',
  CHOICE: 'Seçim Alanları',
  FILE: 'Dosya Alanları',
  ADVANCED: 'Gelişmiş Alanlar',
  TABLE: 'Tablo Alanları',
  INTERACTIVE: 'Etkileşimli Alanlar',
  SOCIAL: 'Sosyal Medya Alanları',
  VISUAL: 'Görsel Alanlar',
  SUSTAINABILITY: 'Sürdürülebilirlik',
};

export const FILE_TYPES = {
  ALL: {
    label: 'Tüm Dosyalar',
    extensions: ['*'],
    mimeTypes: ['*/*'],
    maxSize: 10485760, // 10MB
    icon: FileUploadIcon
  },
  IMAGES: {
    label: 'Resimler',
    extensions: ['.jpg', '.jpeg', '.png', '.gif'],
    mimeTypes: ['image/*'],
    maxSize: 5242880, // 5MB
    icon: ImageIcon
  },
  DOCUMENTS: {
    label: 'Belgeler',
    extensions: ['.pdf', '.doc', '.docx'],
    mimeTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    maxSize: 10485760, // 10MB
    icon: FileUploadIcon
  },
  PDF: {
    label: 'PDF Dosyaları',
    extensions: ['.pdf'],
    mimeTypes: ['application/pdf'],
    maxSize: 20971520, // 20MB - PDF'ler için daha büyük boyut
    icon: PdfIcon
  }
};

export const FIELD_TYPES = [
  // Temel Alanlar
  {
    id: 'text',
    label: 'Kısa Metin',
    icon: TextFieldsIcon,
    category: FIELD_CATEGORIES.BASIC,
    defaultProps: {
      placeholder: 'Metin girin',
      maxLength: 255,
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'textarea',
    label: 'Uzun Metin',
    icon: ShortTextIcon,
    category: FIELD_CATEGORIES.BASIC,
    defaultProps: {
      rows: 4,
      maxLength: 1000,
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'number',
    label: 'Sayı',
    icon: NumbersIcon,
    category: FIELD_CATEGORIES.BASIC,
    defaultProps: {
      min: 0,
      max: 999999,
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },

  // Giriş Alanları
  {
    id: 'email',
    label: 'E-posta',
    icon: EmailIcon,
    category: FIELD_CATEGORIES.INPUT,
    defaultProps: {
      pattern: '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$',
      errorMessage: 'Geçerli bir e-posta adresi girin',
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'phone',
    label: 'Telefon',
    icon: PhoneIcon,
    category: FIELD_CATEGORIES.INPUT,
    defaultProps: {
      pattern: '^[0-9]{10}$',
      errorMessage: 'Geçerli bir telefon numarası girin',
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'url',
    label: 'Web Adresi',
    icon: UrlIcon,
    category: FIELD_CATEGORIES.INPUT,
    defaultProps: {
      pattern: '^https?:\\/\\/.*',
      errorMessage: 'Geçerli bir web adresi girin',
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },

  // Seçim Alanları
  {
    id: 'select',
    label: 'Açılır Liste',
    icon: ListIcon,
    category: FIELD_CATEGORIES.CHOICE,
    defaultProps: {
      options: ['Seçenek 1', 'Seçenek 2', 'Seçenek 3'],
      multiple: false,
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'checkbox',
    label: 'Onay Kutusu',
    icon: CheckBoxIcon,
    category: FIELD_CATEGORIES.CHOICE,
    defaultProps: {
      options: ['Seçenek 1', 'Seçenek 2', 'Seçenek 3'],
      inline: true,
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'radio',
    label: 'Seçenek Düğmeleri',
    icon: RadioButtonCheckedIcon,
    category: FIELD_CATEGORIES.CHOICE,
    defaultProps: {
      options: ['Seçenek 1', 'Seçenek 2', 'Seçenek 3'],
      inline: true,
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },

  // Dosya Alanları
  {
    id: 'file',
    label: 'Dosya Yükleme',
    icon: FileUploadIcon,
    category: FIELD_CATEGORIES.FILE,
    defaultProps: {
      maxFileSize: 10485760, // 10MB
      maxFiles: 1,
      allowMultiple: false,
      uploadText: 'Dosya yüklemek için tıklayın veya sürükleyin',
      uploadSubText: 'Desteklenen formatlar: Tüm dosyalar (max 10MB)',
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'image',
    label: 'Resim Yükleme',
    icon: ImageIcon,
    category: FIELD_CATEGORIES.FILE,
    defaultProps: {
      maxFileSize: 5242880, // 5MB
      maxFiles: 5,
      allowMultiple: false,
      uploadText: 'Resim yüklemek için tıklayın veya sürükleyin',
      uploadSubText: 'Desteklenen formatlar: JPG, PNG, GIF (max 5MB)',
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'pdf',
    label: 'PDF Yükleme',
    icon: PdfIcon,
    category: FIELD_CATEGORIES.FILE,
    defaultProps: {
      maxFileSize: 20971520, // 20MB
      maxFiles: 1,
      allowMultiple: false,
      uploadText: 'PDF dosyası yüklemek için tıklayın veya sürükleyin',
      uploadSubText: 'Desteklenen format: PDF (max 20MB)',
      acceptedTypes: FILE_TYPES.PDF,
    },
    responsive: { xs: 12, sm: 6, md: 6 }, // PDF için daha geniş alan
  },

  // Gelişmiş Alanlar
  {
    id: 'date',
    label: 'Tarih',
    icon: DateIcon,
    category: FIELD_CATEGORIES.ADVANCED,
    defaultProps: {
      format: 'DD/MM/YYYY',
      minDate: null,
      maxDate: null,
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'time',
    label: 'Saat',
    icon: TimeIcon,
    category: FIELD_CATEGORIES.ADVANCED,
    defaultProps: {
      format: 'HH:mm',
      showSeconds: false,
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'rating',
    label: 'Değerlendirme',
    icon: RatingIcon,
    category: FIELD_CATEGORIES.ADVANCED,
    defaultProps: {
      max: 5,
      allowHalf: false,
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'slider',
    label: 'Kaydırıcı',
    icon: SliderIcon,
    category: FIELD_CATEGORIES.ADVANCED,
    defaultProps: {
      min: 0,
      max: 100,
      step: 1,
      marks: true,
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'currency',
    label: 'Para Birimi',
    icon: CurrencyIcon,
    category: FIELD_CATEGORIES.ADVANCED,
    defaultProps: {
      currency: 'TRY',
      min: 0,
      max: 1000000,
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'name',
    label: 'Ad Soyad',
    icon: NameIcon,
    category: FIELD_CATEGORIES.ADVANCED,
    defaultProps: {
      splitFields: true, // Ad ve soyad ayrı alanlar
      pattern: '^[a-zA-ZğüşıöçĞÜŞİÖÇ ]+$',
      errorMessage: 'invalid_name',
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'address',
    label: 'Adres',
    icon: AddressIcon,
    category: FIELD_CATEGORIES.ADVANCED,
    defaultProps: {
      multiline: true,
      rows: 3,
      showMap: false,
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'richtext',
    label: 'Zengin Metin',
    icon: RichTextIcon,
    category: FIELD_CATEGORIES.ADVANCED,
    defaultProps: {
      toolbar: ['bold', 'italic', 'underline', 'link'],
      maxLength: 2000,
    },
    responsive: { xs: 12, sm: 6, md: 4 }, // Responsive ayar
  },
  {
    id: 'table',
    label: 'Tablo',
    icon: TableChartIcon,
    category: FIELD_CATEGORIES.TABLE,
    defaultProps: {
      label: 'Yeni Tablo',
      columns: [
        { header: 'Sütun 1', type: 'text' },
        { header: 'Sütun 2', type: 'text' }
      ],
      minRows: 1,
      allowAddRows: true
    },
    responsive: { xs: 12, sm: 12, md: 12 }, // Tablo tam genişlikte görüntülensin
  },

  // Etkileşimli Alanlar
  {
    id: 'toggle',
    label: 'Açma/Kapama',
    icon: ToggleIcon,
    category: FIELD_CATEGORIES.INTERACTIVE,
    defaultProps: {
      defaultValue: false,
      size: 'medium',
      color: 'primary',
    },
    responsive: { xs: 12, sm: 6, md: 4 },
  },
  {
    id: 'range-slider',
    label: 'Aralık Kaydırıcı',
    icon: RangeSliderIcon,
    category: FIELD_CATEGORIES.INTERACTIVE,
    defaultProps: {
      min: 0,
      max: 100,
      step: 1,
      marks: true,
      valueLabelDisplay: 'auto',
      range: true,
      defaultValue: [20, 80],
    },
    responsive: { xs: 12, sm: 8, md: 6 },
  },
  {
    id: 'color-picker',
    label: 'Renk Seçici',
    icon: ColorPickerIcon,
    category: FIELD_CATEGORIES.INTERACTIVE,
    defaultProps: {
      defaultValue: '#1976d2',
      variant: 'standard',
      showAlpha: false,
    },
    responsive: { xs: 12, sm: 6, md: 4 },
  },
  {
    id: 'gauge',
    label: 'Gösterge',
    icon: GaugeIcon,
    category: FIELD_CATEGORIES.INTERACTIVE,
    defaultProps: {
      min: 0,
      max: 100,
      value: 50,
      size: 'medium',
      color: 'primary',
      showValue: true,
    },
    responsive: { xs: 12, sm: 6, md: 4 },
  },
  {
    id: 'progress',
    label: 'İlerleme Çubuğu',
    icon: ProgressIcon,
    category: FIELD_CATEGORIES.INTERACTIVE,
    defaultProps: {
      min: 0,
      max: 100,
      value: 0,
      variant: 'determinate',
      color: 'primary',
      showLabel: true,
    },
    responsive: { xs: 12, sm: 8, md: 6 },
  },

  // Sosyal Medya Alanları
  {
    id: 'social-links',
    label: 'Sosyal Medya Bağlantıları',
    icon: SocialIcon,
    category: FIELD_CATEGORIES.SOCIAL,
    defaultProps: {
      platforms: ['facebook', 'twitter', 'instagram', 'linkedin', 'youtube'],
      allowMultiple: true,
      validateUrls: true,
    },
    responsive: { xs: 12, sm: 8, md: 6 },
  },
  {
    id: 'facebook',
    label: 'Facebook Profili',
    icon: FacebookIcon,
    category: FIELD_CATEGORIES.SOCIAL,
    defaultProps: {
      placeholder: 'https://facebook.com/kullaniciadi',
      pattern: '^https?:\\/\\/(www\\.)?facebook\\.com\\/.*',
      errorMessage: 'Geçerli bir Facebook URL\'si girin',
    },
    responsive: { xs: 12, sm: 6, md: 4 },
  },
  {
    id: 'twitter',
    label: 'Twitter/X Profili',
    icon: TwitterIcon,
    category: FIELD_CATEGORIES.SOCIAL,
    defaultProps: {
      placeholder: 'https://twitter.com/kullaniciadi',
      pattern: '^https?:\\/\\/(www\\.)?(twitter|x)\\.com\\/.*',
      errorMessage: 'Geçerli bir Twitter/X URL\'si girin',
    },
    responsive: { xs: 12, sm: 6, md: 4 },
  },
  {
    id: 'instagram',
    label: 'Instagram Profili',
    icon: InstagramIcon,
    category: FIELD_CATEGORIES.SOCIAL,
    defaultProps: {
      placeholder: 'https://instagram.com/kullaniciadi',
      pattern: '^https?:\\/\\/(www\\.)?instagram\\.com\\/.*',
      errorMessage: 'Geçerli bir Instagram URL\'si girin',
    },
    responsive: { xs: 12, sm: 6, md: 4 },
  },
  {
    id: 'linkedin',
    label: 'LinkedIn Profili',
    icon: LinkedInIcon,
    category: FIELD_CATEGORIES.SOCIAL,
    defaultProps: {
      placeholder: 'https://linkedin.com/in/kullaniciadi',
      pattern: '^https?:\\/\\/(www\\.)?linkedin\\.com\\/.*',
      errorMessage: 'Geçerli bir LinkedIn URL\'si girin',
    },
    responsive: { xs: 12, sm: 6, md: 4 },
  },
  {
    id: 'youtube',
    label: 'YouTube Kanalı',
    icon: YouTubeIcon,
    category: FIELD_CATEGORIES.SOCIAL,
    defaultProps: {
      placeholder: 'https://youtube.com/channel/kanalid',
      pattern: '^https?:\\/\\/(www\\.)?youtube\\.com\\/(channel|c|user)\\/.*',
      errorMessage: 'Geçerli bir YouTube URL\'si girin',
    },
    responsive: { xs: 12, sm: 6, md: 4 },
  },
  {
    id: 'whatsapp',
    label: 'WhatsApp Numarası',
    icon: WhatsAppIcon,
    category: FIELD_CATEGORIES.SOCIAL,
    defaultProps: {
      placeholder: '+90 555 123 45 67',
      pattern: '^\\+?[1-9]\\d{1,14}$',
      errorMessage: 'Geçerli bir WhatsApp numarası girin',
      countryCode: '+90',
    },
    responsive: { xs: 12, sm: 6, md: 4 },
  },

  // Görsel Alanlar
  {
    id: 'signature',
    label: 'Dijital İmza',
    icon: SignatureIcon,
    category: FIELD_CATEGORIES.VISUAL,
    defaultProps: {
      width: 400,
      height: 200,
      backgroundColor: '#ffffff',
      penColor: '#000000',
      penWidth: 2,
      clearButton: true,
    },
    responsive: { xs: 12, sm: 8, md: 6 },
  },
  {
    id: 'drawing',
    label: 'Çizim Alanı',
    icon: DrawingIcon,
    category: FIELD_CATEGORIES.VISUAL,
    defaultProps: {
      width: 500,
      height: 300,
      backgroundColor: '#ffffff',
      tools: ['pen', 'eraser', 'line', 'rectangle', 'circle'],
      colors: ['#000000', '#ff0000', '#00ff00', '#0000ff'],
    },
    responsive: { xs: 12, sm: 10, md: 8 },
  },
  {
    id: 'qr-code',
    label: 'QR Kod Okuyucu',
    icon: QrCodeIcon,
    category: FIELD_CATEGORIES.VISUAL,
    defaultProps: {
      autoStart: false,
      showPreview: true,
      resultFormat: 'text',
    },
    responsive: { xs: 12, sm: 6, md: 4 },
  },

  // Sürdürülebilirlik ve Çevre Alanları
  {
    id: 'carbon-calculator',
    label: 'Karbon Ayak İzi Hesaplayıcı',
    icon: EcoIcon,
    category: FIELD_CATEGORIES.SUSTAINABILITY,
    defaultProps: {
      calculationType: 'comprehensive', // 'basic' | 'comprehensive' | 'custom'
      metrics: {
        paperSaved: true,
        treesSaved: true,
        co2Reduced: true,
        energySaved: true,
        waterSaved: true
      },
      displayFormat: 'cards', // 'cards' | 'chart' | 'infographic'
      animateCounters: true,
      showComparison: true,
      comparisonBaseYear: 2023,
      customMessage: 'FormClicker ile dijital dönüşümünüz çevreye olan katkınız!',
      brandingEnabled: true,
    },
    responsive: { xs: 12, sm: 12, md: 8 },
  },
  {
    id: 'eco-impact-display',
    label: 'Çevresel Etki Göstergesi',
    icon: LeafIcon,
    category: FIELD_CATEGORIES.SUSTAINABILITY,
    defaultProps: {
      impactType: 'realtime', // 'realtime' | 'annual' | 'cumulative'
      displayMetrics: ['paperSaved', 'treesProtected', 'co2Reduction'],
      visualStyle: 'modern', // 'modern' | 'minimal' | 'detailed'
      showProgress: true,
      targetGoals: {
        paperSaved: 10000, // sheets
        treesProtected: 50,
        co2Reduction: 500 // kg
      },
      celebrateAchievements: true,
      shareEnabled: true,
    },
    responsive: { xs: 12, sm: 8, md: 6 },
  },
  {
    id: 'sustainability-score',
    label: 'Sürdürülebilirlik Skoru',
    icon: RecyclingIcon,
    category: FIELD_CATEGORIES.SUSTAINABILITY,
    defaultProps: {
      scoreRange: 100,
      factors: {
        digitalUsage: 40,    // %40 dijital kullanım
        paperReduction: 30,  // %30 kağıt azaltma
        efficiency: 20,      // %20 verimlilik
        innovation: 10       // %10 yenilik
      },
      displayFormat: 'circular', // 'circular' | 'linear' | 'badge'
      showBreakdown: true,
      includeTips: true,
      gamification: true,
      leaderboard: false,
    },
    responsive: { xs: 12, sm: 6, md: 4 },
  },
  {
    id: 'green-certificate',
    label: 'Yeşil Sertifika Üreticisi',
    icon: CertificateIcon,
    category: FIELD_CATEGORIES.SUSTAINABILITY,
    defaultProps: {
      certificateType: 'paper-free', // 'paper-free' | 'carbon-neutral' | 'eco-friendly'
      includeQRCode: true,
      includeLogo: true,
      customTemplate: 'FormClicker Green Business Certificate',
      downloadFormat: 'pdf', // 'pdf' | 'png' | 'jpg'
      watermark: true,
      validityPeriod: 365, // days
      autoGenerate: true,
    },
    responsive: { xs: 12, sm: 8, md: 6 },
  },
];

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// Dosya tipi kontrolü
export const isFileTypeAllowed = (file, acceptedTypes) => {
  if (acceptedTypes.extensions.includes('*')) return true;
  const extension = '.' + file.name.split('.').pop().toLowerCase();
  return acceptedTypes.extensions.includes(extension);
};

// Dosya boyutu kontrolü
export const isFileSizeAllowed = (file, maxSize) => {
  return file.size <= maxSize;
};

export const getFieldTypeById = (id) => {
  return FIELD_TYPES.find(type => type.id === id);
};

export const getFieldsByCategory = (category) => {
  return FIELD_TYPES.filter(type => type.category === category);
};

export const getAllCategories = () => {
  return Object.values(FIELD_CATEGORIES);
};